import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import MappingIntro from './MappingIntro';
import ImportHooray from './ImportHooray';
import { trackUploadSpreadsheetStepCompleted } from '../../../../../util/trackingHelper';
import featureFlag from '../../../../../util/featureFlags';

const isSpreadsheetUploadTracking = featureFlag.get('isSpreadsheetUploadTracking');

const ImportSuccess = ({ onMappingStart, flowRunId }) => {
  const [showIntro, setShowIntro] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setShowIntro(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isSpreadsheetUploadTracking) {
      trackUploadSpreadsheetStepCompleted(
        {
          step_name: 'Upload Spreadsheet',
          step_number: 1,
          step_value_type: 'success',
          step_value: null,
        },
        flowRunId
      );
    }
  }, []);

  return showIntro ? (
    <MappingIntro onMappingStart={onMappingStart} flowRunId={flowRunId} />
  ) : (
    <ImportHooray />
  );
};

ImportSuccess.propTypes = {
  onMappingStart: PropTypes.func,
  flowRunId: PropTypes.string,
};

export default ImportSuccess;



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/content/ImportSuccess.jsx